import React from 'react';

const Counter = () => <div className="counter" />;

export default Counter;
